uniform float uTime;
uniform float uSize;
uniform vec2 uResolution;

uniform float uInfluence;
uniform float uSpeed;
uniform float uIntensity;
uniform float uDistFromCenter;

uniform bool uExplosion;
uniform float uProgress;

varying vec3 vColor;

#include ../includes/cnoise.glsl
#include ../includes/remap.glsl

void main() {
    vec3 newPosition = position;

    if(uExplosion) { // Exploding
        float explodingProgress = remap(uProgress, 0.0, 0.1, 0.0, 2.5);
        newPosition *= explodingProgress;
    } else { //Hairs waving
        float angle = cnoise(position * uInfluence + vec3(0.0, uTime * uSpeed, 0.0)) * uIntensity;

        float distFactor = clamp(length(position) / 1.5, 0.0, 1.0); //sphere raidus 1
        distFactor = pow(distFactor, uDistFromCenter); // Exponential scaling (adjust power as needed)

        vec3 displacement = normalize(cross(normal, vec3(0.0, 1.0, 0.0))) * angle * distFactor;

        newPosition += displacement;
    }

    vec4 modelPosition = modelMatrix * vec4(newPosition, 1.0);
    vec4 viewPosition = viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;

    gl_Position = projectedPosition;

    ///////////////////
    // vec4 modelPosition = modelMatrix * vec4(position, 1.0);//from simon
    // vec4 viewPosition = viewMatrix * modelPosition; //from simon
    // gl_Position = projectionMatrix * viewPosition; //from simon

    /**
     * Size
     */
    gl_PointSize = uSize * uResolution.y * 0.0016;
    gl_PointSize *= (1.0 / -viewPosition.z);

    /**
     * Varyings
     */
    vColor = color;
    // Intento fallido float vDistFromCenter = clamp(length(modelPosition.xyz) / 2.0, 0.0, 1.0); // Dividing by 2.0 ensures it's normalized for a sphere of radius ~1

}